import axios from 'axios';
import { API_BASE_URL_OPEN } from '../../App/azure/api';

export const checkewayPayment = async (accessCode) => {
    let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${API_BASE_URL_OPEN}/checkewayPayment?accessCode=${accessCode}`,
    };

    try {
        const response = await axios(config);
        return response;
    } catch (error) {
        console.error(error);
        return error;
    }
}